/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Step_4Inputs */

const en_svc_research_step_4 = /** @type {(inputs: Svc_Research_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch with a record of every run and every source it used.`)
};

const lv_svc_research_step_4 = /** @type {(inputs: Svc_Research_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palaižam ar katras palaišanas un katra avota pierakstu.`)
};

/**
* | output |
* | --- |
* | "Launch with a record of every run and every source it used." |
*
* @param {Svc_Research_Step_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_step_4 = /** @type {((inputs?: Svc_Research_Step_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Step_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_step_4(inputs)
	return en_svc_research_step_4(inputs)
});